import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  fromDate: null,     
  toDate: null,       
  filterModel: null,  
  sortModel: null,    
};

const grnListSlice = createSlice({
  name: 'grnList',
  initialState,
  reducers: {
    setDates(state, action) {
      const { fromDate, toDate } = action.payload || {};
      state.fromDate = fromDate ?? null;
      state.toDate = toDate ?? null;
    },
    setFilterModel(state, action) {
      state.filterModel = action.payload || null;
    },
    setSortModel(state, action) {
      state.sortModel = action.payload || null;
    },
    clearGrnListState() {
      return initialState;
    },
  },
});

export const { setDates, setFilterModel, setSortModel, clearGrnListState } =
  grnListSlice.actions;

export default grnListSlice.reducer;
